/*eslint-disable dot-notation*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useRef } from 'react';
import './style.scss';
import clsx from 'clsx';
import TextField from '@mui/material/TextField';
import { Image, RichText, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import Loader from './Loader';
import ismatch from 'lodash.ismatch';
import isEmpty from 'lodash.isempty';
import some from 'lodash.some';
import { withTranslation } from 'react-i18next';

const AccountGeneratorComponent = ({ fields = {}, params, i18n }) => {
  // const [result, setResult] = useState({output: {IBAN_NUMBER: 3123123123, NEW_AC_NO: 3123123123666, RETURN_CODE: "000", ERROR_MESSAGE: "SUCCESS"}});
  const [result, setResult] = useState('');
  const [gotResult, setGotResult] = useState(false);
  const [selectionOptionScheme, setSelectionOptionScheme] = useState({});
  const [showNextLevelAfter, setShowNextLevelAfter] = useState([]);
  const [formData, setFormData] = useState({});
  // Copy URL Click Class To Add
  const showRecaptcha = true; // should be coming fields
  const context = useSitecoreContext();
  let recaptchaKey = context?.sitecoreContext?.siteConfigurations?.googleReCAPTCHAKey;
  const [loading, setLoading] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  let shouldRenderRecaptcha = showRecaptcha && recaptchaKey !== '' && !loading;
  const customErrorMessage = (
    <span>
      An error occurred while generating your IBAN number. For further details, please{' '}
      <a href={`/${i18n.language}/about-fab/contact-us`}>contact us</a>.
    </span>
  );

  const [copyClass, setCopyClass] = useState(false);
  const [inputErrors, setInputErrors] = useState({});
  const [error, setError] = useState({
    status: false,
    msg: '',
  });

  useEffect(() => {
    setFormData({});
    setInputErrors({});
  }, [selectionOptionScheme, showNextLevelAfter]);

  const {
    accountTypeHeading,
    corporateBankingLabel,
    personalBankingLabel,
    customerTypeHeading,
    egyptianLabel,
    nonResident,
    commercialIdLabel,
    taxIdLabel,
    inputPlaceHolder,
    idTypeHeading,
    buttonText,
    taxTypeNumber,
    commercialTypeNumber,
    nationalIdTypeNumber,
    passportTypeNumber,
    resultIconTooltip,
    description,
    endPoint,
    resultButtonText,
    resultDescription,
    resultIcon,
    resultLabel,
    title,
    emptyMessage,
    lengthMessage,
    generalErrorMessage,
  } = fields;
  const existingAccountNumber = { value: 'Existing Account Number' };
  const existingAccountNumberPlaceholder = { value: 'Existing Account Number' };

  const nationalIdNumber = { value: 'National ID number' };
  const nationalIdNumberPlaceholder = { value: 'National ID number' };

  const isRadioPersonalBanking = selectionOptionScheme[0]?.value === personalBankingLabel?.value;
  const data = {
    buildForm: [
      {
        renderType: 'radio',
        initial: true,
        title: accountTypeHeading,
        id: 0,
        children: [{ labelName: personalBankingLabel }, { labelName: corporateBankingLabel }],
      },
      {
        renderType: 'radio',
        title: isRadioPersonalBanking ? customerTypeHeading : idTypeHeading,
        id: 1,
        renderFullWidth: !isRadioPersonalBanking,
        children: [
          { labelName: isRadioPersonalBanking ? egyptianLabel : commercialIdLabel },
          { labelName: isRadioPersonalBanking ? nonResident : taxIdLabel },
        ],
      },
      {
        label: nationalIdNumber,
        placeholder: nationalIdNumberPlaceholder,
        renderType: 'text',
        type: 'tel',
        id: 2,
        initial: true,
        inputKey: 'nationalIdNumber',
        showIfParentValue: [egyptianLabel],
        validation: 'number',
        // maxLength: nationalIdTypeNumber?.value
      },
      {
        label: existingAccountNumber,
        placeholder: existingAccountNumberPlaceholder,
        renderType: 'text',
        type: 'tel',
        id: 2,
        initial: true,
        inputKey: 'existingAccountNumber',
        showIfParentValue: [egyptianLabel, nonResident, commercialIdLabel],
        validation: 'number',
        // maxLength: nationalIdTypeNumber?.value
      },
      {
        label: inputPlaceHolder,
        placeholder: inputPlaceHolder,
        renderType: 'text',
        type: 'tel',
        id: 2,
        initial: true,
        inputKey: 'passPort',
        showIfParentValue: [nonResident],
        validation: 'any',
        maxLength: passportTypeNumber?.value,
      },
      {
        label: commercialIdLabel,
        placeholder: commercialIdLabel,
        renderType: 'text',
        type: 'tel',
        id: 2,
        initial: true,
        inputKey: 'commercialIdLabel',
        showIfParentValue: [taxIdLabel, commercialIdLabel],
        validation: 'number',
        maxLength: commercialTypeNumber?.value,
      },
      {
        label: taxIdLabel,
        placeholder: taxIdLabel,
        renderType: 'text',
        type: 'tel',
        id: 2,
        initial: true,
        inputKey: 'taxIdLabel',
        showIfParentValue: [taxIdLabel],
        validation: 'number',
        maxLength: taxTypeNumber?.value,
      },
    ],
    validationSchema: {
      nationalIdNumber: nationalIdTypeNumber?.value,
      existingAccountNumber: nationalIdTypeNumber?.value,
      passPort: passportTypeNumber?.value,
      commercialIdLabel: commercialTypeNumber?.value,
      taxIdLabel: taxTypeNumber?.value,
    },
  };
  const shouldRenderButtonText = !!buttonText?.value;
  const shouldRenderDescription = !!description?.value;
  const shouldRenderEndpoint = !!endPoint?.value;
  const shouldRenderResultButtonText = !!resultButtonText?.value;
  const shouldRenderResultDescription = !!resultDescription?.value;
  const shouldRenderResultIcon = !!resultIcon?.value?.src;
  const shouldRenderResultIconTooltip = !!resultIconTooltip?.value;
  const shouldRenderResultLabel = !!resultLabel?.value;
  const shouldRenderTitle = !!title?.value;

  const removeIdFromList = (id) => {
    const targetList = [...showNextLevelAfter];
    return targetList.filter((el) => el !== id);
  };

  const handleSetSelectionOptionScheme = (value, id) => {
    setFormData({});
    const targetObject = { [id]: { value } };
    if (id === 0) {
      const shouldRevert = value === selectionOptionScheme[0]?.value;
      setSelectionOptionScheme(shouldRevert ? {} : { ...targetObject });
      setShowNextLevelAfter(shouldRevert ? [] : [0]);
    } else {
      const hasObjectSelection = ismatch(selectionOptionScheme, { ...targetObject });
      const schemeClone = { ...selectionOptionScheme };
      hasObjectSelection && delete schemeClone[id];
      !hasObjectSelection && Object.assign(schemeClone, { ...targetObject });
      setSelectionOptionScheme({ ...schemeClone });
      setShowNextLevelAfter((prev) =>
        hasObjectSelection
          ? [...removeIdFromList(id)]
          : !prev.includes(id)
          ? [...prev, id]
          : [...prev]
      );
    }
  };

  const hanldeWetherFieldShouldShowByLevel = (data) => {
    const { initial, id } = data;
    const shouldInitiallyBeRendered = initial;
    const previousLevel = Number(id - 1);
    const levelsListIncludesPrevious = showNextLevelAfter.includes(previousLevel);
    const idLessThanLevelsLength = id <= showNextLevelAfter.length;
    return !shouldInitiallyBeRendered ? idLessThanLevelsLength && levelsListIncludesPrevious : true;
  };

  const hanldeWetherFieldShouldShowByData = (data) => {
    const { showIfParentValue } = data;
    const dummyLevelsList = { ...selectionOptionScheme };
    const dataToCheckFor = Object.values(dummyLevelsList).pop();
    const shouldRenderForDataEntry = !isEmpty(showIfParentValue)
      ? some(showIfParentValue, dataToCheckFor)
      : false;
    return shouldRenderForDataEntry && showNextLevelAfter.includes(0);
  };

  const RadioButtonComponent = ({ labelName, id }) => {
    const isSelected = ismatch(selectionOptionScheme, { [id]: labelName });
    return (
      <div
        onClick={() => handleSetSelectionOptionScheme(labelName.value, id)}
        className="filters__modal-body_category-filters_radio"
      >
        <div className={clsx('radio-container', isSelected && 'selected')}>
          <div className="radio-container--inner"></div>
        </div>
        <span className="radioText">{<Text className="radio-content" field={labelName} />}</span>
      </div>
    );
  };

  const onRecaptchachange = (value) => {
    setRecaptchaValue(value === null ? null : value);
  };

  const copyUrlClick = (e) => {
    e.stopPropagation();
    if (!copyClass) {
      setCopyClass((prev) => !prev);
      setTimeout(() => {
        setCopyClass((prev) => !prev);
      }, 500);
    }
    navigator?.clipboard?.writeText(result);
  };

  const validateInputs = () => {
    const errors = {};
    for (const [key, value] of Object.entries(formData)) {
      const isErroneous = Number(value.length) < Number(data.validationSchema[key]);
      isErroneous && Object.assign(errors, { ...errors, [key]: 'error' });
    }
    setInputErrors({ ...errors });
    return errors;
  };

  const generateIban = async () => {
    const errors = await validateInputs();
    if (!isEmpty(recaptchaValue) && isEmpty(errors) && !isEmpty(formData)) {
      try {
        setLoading(true);
        let endpointUrl = endPoint?.value;
        // endrefactoring
        endpointUrl = endpointUrl.replace(
          '{accountNumber}',
          formData?.existingAccountNumber?.replace(/ /g, '')
        );
        endpointUrl = endpointUrl.replace('{recaptchaToken}', recaptchaValue);
        const req = await fetch(endpointUrl);
        let res = await req.text();
        console.log('res: ', res);
        let temp = res.toString().toLowerCase();
        temp = res.replace(/"/g, '');
        setLoading(false);
        if (temp.startsWith('invalid') || temp.startsWith('error')) {
          setError({
            status: true,
            msg: generalErrorMessage?.value,
          });
        } else {
          // setResult(res.replace(/"/g, ""));
          console.log('else');
          console.log(JSON.parse(res));
          setResult(JSON.parse(res));
          setGotResult(true);
        }
      } catch (e) {
        console.log('error', e.message);
        setLoading(false);
        setError({
          status: true,
          msg: generalErrorMessage?.value,
        });
      }
    }
  };

  const generateAnotherIban = () => {
    setGotResult(false);
    setRecaptchaValue(null);
    setInputErrors({});
    setFormData({});
    setSelectionOptionScheme({});
    setShowNextLevelAfter([]);
    if (typeof window !== 'undefined' && window.grecaptcha) {
      window.grecaptcha.reset();
    }
  };

  const handleFormChange = (e, inputKey, validation, maxLength) => {
    const dataFromForm = { ...formData };
    const formatedDataEntry =
      validation === 'number'
        ? e.target.value.slice(0, maxLength).replace(/\D/g, '')
        : e.target.value.slice(0, maxLength);
    const targetObject = { ...dataFromForm, [inputKey]: formatedDataEntry };
    setFormData({ ...targetObject });
  };

  const renderTextInput = (data, index) => {
    const { placeholder, label, type, inputKey, validation, maxLength } = data;
    const textFieldProps = {
      InputLabelProps: { className: 'form-element-label' },
      disabled: gotResult,
      error: !!inputErrors[inputKey] || error.status,
      className: 'account-input form-element',
      label: !!label ? label.value : '',
      helperText: !!inputErrors[inputKey] ? inputErrors[inputKey] : '',
      placeholder: !!placeholder ? placeholder.value : '',
      value: formData[inputKey],
      type,
      default: '',
      key: `radio_input_${index}`,
      fullWidth: true,
      onFocus: () => setInputErrors({}),
      onChange: (e) => handleFormChange(e, inputKey, validation, maxLength),
    };
    return (
      <>
        <TextField {...textFieldProps} />
      </>
    );
  };

  const renderAssociatedRadioButtons = (radioButtonsToRender, id) => {
    return radioButtonsToRender.map((element, index) => {
      const { labelName } = element;
      const radioButtonComponent = { labelName, id };
      return <RadioButtonComponent {...radioButtonComponent} key={index} />;
    });
  };

  const renderRadio = (data, index) => {
    const { children, title, id, renderFullWidth } = data;
    return (
      <div className="labelRadioInputGroup" key={`radio_input_${index}`}>
        <span className="radioLabel">{<Text field={title} />}</span>
        <div className={clsx(renderFullWidth && 'renderRadioFull', 'radioButtonContainer')}>
          {renderAssociatedRadioButtons(children, id)}
        </div>
      </div>
    );
  };

  const renderFields = (data) => {
    return data.map((element, index) => {
      const { id } = element;
      const isIdLevelTwo = id === 2;
      const shouldShowField = hanldeWetherFieldShouldShowByLevel(element);
      const shouldShowFieldBasedOnData = isIdLevelTwo && hanldeWetherFieldShouldShowByData(element);
      const shouldRenderElement = isIdLevelTwo
        ? shouldShowField && shouldShowFieldBasedOnData
        : shouldShowField;
      const isElementTypeRadio = element?.renderType === 'radio';
      const typeToRender = isElementTypeRadio
        ? renderRadio(element, index)
        : renderTextInput(element, index);
      const elementToRender = shouldRenderElement ? typeToRender : <></>;
      return elementToRender;
    });
  };
  return (
    <div className={clsx('iban-generator content', 'add-margins', params?.Styles)}>
      <div className="row iban-geneartor-container">
        <div className="col-12 col-md-6 left-side">
          {shouldRenderTitle && (
            <h3>
              <Text field={title} />
            </h3>
          )}
          {shouldRenderDescription && <RichText field={description} className="left-side-desc" />}
          <div className="input-container">{renderFields(data.buildForm)}</div>
          {shouldRenderRecaptcha && (
            <div className="recaptcha">
              <ReCAPTCHA sitekey={recaptchaKey} onChange={onRecaptchachange} />
            </div>
          )}
          {loading ? (
            <div className="loader-container">
              <Loader />
            </div>
          ) : (
            <button
              onClick={() => generateIban()}
              className={clsx(
                'button button-contained-primary generate-btn',
                gotResult && 'button-display',
                !(
                  shouldRenderRecaptcha &&
                  !isEmpty(recaptchaValue) &&
                  !isEmpty(formData) &&
                  isEmpty(inputErrors)
                ) && 'disabled-btn'
              )}
            >
              {shouldRenderButtonText ? <Text field={buttonText} /> : ''}
            </button>
          )}
        </div>
        <div className={clsx('col-12 col-sm-6 right-side', gotResult && 'right-side-display')}>
          {/* {shouldRenderResultLabel && */}
          <div className="result-title">Your new account number</div>
          {/* } */}
          <div className="result-field">
            <div className="result-input">{result?.output?.['NEW_AC_NO']}</div>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className={clsx('custom-tooltip lightMode upward')}>
                  {shouldRenderResultIconTooltip && <Text field={resultIconTooltip} />}
                </Tooltip>
              }
            >
              <div
                onClick={copyUrlClick}
                className={clsx('copy-url', copyClass && 'copy-effect')}
                role="button"
              >
                {shouldRenderResultIcon && <Image field={resultIcon} />}
              </div>
            </OverlayTrigger>
          </div>
          <div className="result-title">Your new IBAN number</div>
          <div className="result-field">
            <div className="result-input">{result?.output?.['IBAN_NUMBER']}</div>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className={clsx('custom-tooltip lightMode upward')}>
                  {shouldRenderResultIconTooltip && <Text field={resultIconTooltip} />}
                </Tooltip>
              }
            >
              <div
                onClick={copyUrlClick}
                className={clsx('copy-url', copyClass && 'copy-effect')}
                role="button"
              >
                {shouldRenderResultIcon && <Image field={resultIcon} />}
              </div>
            </OverlayTrigger>
          </div>
          {shouldRenderResultDescription && (
            <RichText className="result-note" field={resultDescription} />
          )}
          <button
            onClick={generateAnotherIban}
            className="button button-contained-secondary result-btn"
          >
            {shouldRenderResultButtonText && <Text field={resultButtonText} />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(AccountGeneratorComponent);
